<template>
  <!-- Search Bar -->
  <v-text-field
    class="search-bar"
    ref="searchBar"
    @input="$emit('input', $event)"
    :dark="dark"
    placeholder="Search"
    filled
    single-line
    flat
    hide-details
    rounded
    dense
  >
    <template v-slot:append>
      <v-btn class="search-icon" icon width="40px" height="40px" active-class="no-active">
        <v-icon medium> mdi-magnify </v-icon>
      </v-btn>
    </template>
  </v-text-field>
</template>

<style scoped>
.v-text-field--rounded >>> .v-input__control > .v-input__slot {
  padding-right: 0;
}

.theme--light.v-text-field--rounded >>> .v-input__control > .v-input__slot {
  background-color: rgba(0, 0, 0, 0.08);
}

.v-text-field >>> .v-input__append-inner {
  margin-top: 0 !important;
}

.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
</style>

<script>
export default {
  name: "search-bar",

  props: {
    dark: { type: Boolean, default: false },
  },

  methods: {},
};
</script>
